import React, { useEffect } from 'react';
import { connect } from 'react-redux';

import { AppPermissions } from 'src/pages/App/AppPermissions';
import { fetchCurrentUserPermissionsAction, fetchCurrentUserAction } from 'src/redux/actions/currentUser';

const mapStateToProps = ({ currentUser }) => ({
  currentUser
});

const mapDispatchToProps = dispatch => ({
  fetchCurrentUser: () => dispatch(fetchCurrentUserAction()),
  fetchCurrentUserPermissions: () => dispatch(fetchCurrentUserPermissionsAction()),
});

const withData = Component => {
  const AppPermissionsWithData = ({
    authorized,
    children,
    currentUser,
    fetchCurrentUser,
    fetchCurrentUserPermissions,
    refreshToken,
  }) => {
    useEffect(() => {
      if (authorized) {
        fetchCurrentUser();
        fetchCurrentUserPermissions();
      }
    }, [refreshToken]);

    return (
      <Component authorized={authorized} currentUser={currentUser}>{children}</Component>
    );
  };

  return AppPermissionsWithData;
};

export const AppPermissionsContainer = connect(mapStateToProps, mapDispatchToProps)(withData(AppPermissions));
